import {
    getOriented,
    triageMyInbox,
    findQuickWins,
    needsUrgentReplies,
    showTopActionItems,
    latestOnTopic,
    whatToGetToFirst,
    showMyTopThreeEmails,
    inboxBriefing,
    type Suggestions,
} from '../utils/suggestionCatalog';
import { isUserCommercialPremium } from './isUserCommercialPremium';
import { isFeatureEnabled } from 'owa-feature-flags';
import { shouldShowInboxBriefingSUA } from './inboxBriefingUtils';

/**
 * Helper function to navigate the A/B/C/D experiment structure for empty reading pane suggestions.
 * Three strings are being tested, split into three flights.
 * Flight name structure is: copilot-dab-mail-empty-rp-sua-treatment-A, -B, -C
 *
 * Note that the first two suggestions are always static, with only the third suggestion changing based on flight.
 */
export function getEmptyReadingPaneSuggestions(): Suggestions {
    let baseSuggestions: Suggestions;

    // Non-Commercial Premium users are excluded from the SUA reading pane experiment,
    // just return original set of three suggestions
    if (!isUserCommercialPremium()) {
        baseSuggestions = [triageMyInbox, getOriented, findQuickWins];
    } else if (isFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-A')) {
        baseSuggestions = [showTopActionItems, latestOnTopic, needsUrgentReplies];
    } else if (isFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-B')) {
        baseSuggestions = [showTopActionItems, latestOnTopic, whatToGetToFirst];
    } else if (isFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-C')) {
        baseSuggestions = [showTopActionItems, latestOnTopic, showMyTopThreeEmails];
    } else {
        // User not in experiment (e.g. control flight), return original set of three suggestions
        baseSuggestions = [triageMyInbox, getOriented, findQuickWins];
    }

    if (shouldShowInboxBriefingSUA()) {
        // Add inbox briefing as 4th suggestion
        baseSuggestions.push(inboxBriefing);
    }

    return baseSuggestions;
}
